export const connectClientGuideline = ({ intl }) => [
  {
    target: '.client-entry.expanded button.connect-inactive',
    content: 'jr-cc-1',
    placement: 'auto',
    disableBeacon: true,
    isFixed: true,
    disableScrolling: true,
    title: intl.formatMessage({ id: 'jr-cc-1-title' }),
    tutorialItemId: 'c04'
  }
];
